var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "gfu-collapsible _bd--none _tc--inherit",
        { "gfu-collapsible--expanded": _vm.isExpanded },
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "_flex _ai-c _gap-1 _cur-p",
          attrs: { "data-qa": "collapsible:trigger" },
          on: { click: _vm.toggleExpand },
        },
        [
          _c("base-icon", { attrs: { name: _vm.iconName } }),
          _vm._v(" "),
          _vm._t("trigger", null, { isExpanded: _vm.isExpanded }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.contentClassList,
          attrs: { "data-qa": "collapsible:content" },
        },
        [_vm._t("content")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }